import {
  KalturaAssetFilter,
  KalturaChannelFilter,
  KalturaPersonalListSearchFilter,
  KalturaScheduledRecordingProgramFilter,
  KalturaSearchAssetFilter,
  KalturaSearchAssetListFilter,
} from '../../filters';
import { requestPhoenix } from '../../network';
import { requestPhoenixAllPages } from '../../network/requestPhoenixAllPages';
import {
  KalturaAssetListResponse,
  KalturaFilterPager,
  KalturaDetachedResponseProfile,
  KalturaOnDemandResponseProfile,
} from '../../objects';

export type FetchAssetListFilter =
  | KalturaAssetFilter
  | KalturaChannelFilter
  | KalturaPersonalListSearchFilter
  | KalturaSearchAssetFilter
  | KalturaSearchAssetListFilter
  | KalturaScheduledRecordingProgramFilter;
// | KalturaBundleFilter
// | KalturaChannelExternalFilter
// | KalturaRelatedExternalFilter
// | KalturaSearchExternalFilter
// | KalturaRelatedFilter

export type FetchAssetListArgs = {
  filter?: FetchAssetListFilter;
  pager?: KalturaFilterPager;
  responseProfile?: KalturaDetachedResponseProfile | KalturaOnDemandResponseProfile;
  allPages?: boolean;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/asset/action/list
 */
export async function fetchAssetList<T>({ filter, pager, responseProfile, allPages }: FetchAssetListArgs) {
  const requestFn = allPages ? requestPhoenixAllPages : requestPhoenix;

  // TODO: add ability to apply T extends/satisfies KalturaAsset when responseProfile is not provided since
  //  this will be no longer true
  const response = await requestFn<KalturaAssetListResponse<T>>({
    path: '/asset/action/list',
    body: { filter, pager, responseProfile },
  });

  return {
    ...response,
    objects: response.objects?.length ? response.objects : [],
  };
}
